import { render } from "./projectTeamMembersList.vue?vue&type=template&id=94df6050&ts=true"
import script from "./projectTeamMembersList.vue?vue&type=script&lang=ts"
export * from "./projectTeamMembersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__